import { render, staticRenderFns } from "./PJTHarianPage.vue?vue&type=template&id=71e28bd0"
import script from "./PJTHarianPage.vue?vue&type=script&lang=js"
export * from "./PJTHarianPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports